import React, { useState, useEffect } from 'react'
import { RateStarPopup } from '../popup/rateStarPopup'
import { ReportPopup } from '../popup/reportPopup'
import callApi from '../../util/callApi';
import { NotificationManager } from "react-notifications";

export const BoxActionComment = (props) => {

    const { root_comment_id, _id, total_thank, is_mod, author_id, status, upvote_count, is_upvote, is_thank, total_star } = props.data_comment;

    const [visiblePopupStar, setPopupStar] = useState(false);
    const [visiblePopupReport, setPopupReport] = useState(false);
    const [isUpvote, setUpVote] = useState(Boolean(is_upvote));
    const [upvoteCount, setUpVoteCount] = useState(Number(upvote_count) || 0);

    const [isThank, setIsThank] = useState(Boolean(is_thank));
    const [totalThank, setTotalThank] = useState(Number(total_thank) || 0);

    const [totalStar, setTotalStar] = useState(Number(total_star) || 0);
    const [reasonRate, setReasonRate] = useState('');
    const [numberRateStar, setNumberRateStar] = useState(0);

    const [isReport, setReport] = useState(([4, 5].includes(status) ? true : false));


    const handleShowPopup = (text) => {
        switch (text) {
            case "report":
                setPopupReport(true)
                break;
            case "confirm":
                break;
            case "vote":
                setPopupStar(true)
                break;
            default:
                break;
        }
    }

    const dataStarRating = [
        { star: 1, tip: 'Trả lời vô nghĩa' },
        { star: 2, tip: 'Trả lời sai' },
        { star: 3, tip: 'Cũng được' },
        { star: 4, tip: 'Hay' },
        { star: 5, tip: 'Quá tuyệt' }
    ];

    const handleHidePopup = (event) => {
        const { target } = event;
        if (target.className == "popupReport") { setPopupReport(false) }
        if (target.className == "popupConfirm") { setPopupReport(false) }
        if (target.className == "popupVoteStar") { setPopupStar(false) }
    }

    const handleCancel = () => {
        setPopupStar(false)
        setPopupReport(false)
    }

    const handleRatingStar = (numberStar) => {
        if(author_id == props.user_id){
            NotificationManager.error('Không thể vote sao cho chính bình luận của mình!', '', 1300);
            return ;
        }
        if(props.rootAuthorId != props.user_id){
            NotificationManager.error('Bạn không phải chủ câu hỏi, nên không thể vote sao!', '', 1300);
            return ;
        }
        setNumberRateStar(numberStar);
        if (numberStar < 3) {
            handleShowPopup('vote')
            return;
        }
        callApiRatingStar(numberStar, '');
    }

    const handleChangeInputStar = async (event) => {
        const { name, value } = event.target;
        setReasonRate(value)
    }

    const onFinishPopupStar = () => {
        callApiRatingStar(numberRateStar, reasonRate)
    }

    const handleReplied = () => {
        props.setActionId('replied', _id);
    }

    const onFinishPopupReport = (data) => {
        const { type, reason } = data;
        callApiReport(type, reason);
    }


    // Action

    const callApiUpvote = async () => {
        const dataCall = await callApi('v1/user_comment/upDownVote', 'post', { comment_id: _id });
        if (dataCall && dataCall.status == 1) {
            if (isUpvote) {
                setUpVoteCount(upvoteCount - 1)
            } else {
                setUpVoteCount(upvoteCount + 1)
            }
            setUpVote(!isUpvote)
        } else {
            NotificationManager.error(dataCall.message, '', 1300);
        }
    }

    const callApiThank = async () => {
        const dataCall = await callApi('v1/user_comment/thank', 'post', { comment_id: _id });
        if (dataCall && dataCall.status == 1) {
            if (isThank) {
                setTotalThank(totalThank - 1)
            } else {
                setTotalThank(totalThank + 1)
            }
            setIsThank(!isThank)
        } else {
            NotificationManager.error(dataCall.message, '', 1300);
        }
    }

    const callApiRatingStar = async (numberStar, reasonRating = '') => {
        const dataCall = await callApi('v1/user_comment/rate', 'post', { comment_id: _id, number_star: numberStar, reason_content: reasonRating });
        if (dataCall && dataCall.status == 1) {
            setTotalStar(numberStar)
            setReasonRate('')
            handleCancel();
            NotificationManager.success('Cảm ơn bạn đã đánh giá!', '', 1300);
        } else {
            NotificationManager.error(dataCall.message, '', 1300);
        }
    }


    const callApiReport = async (type, reason) => {
        const dataCall = await callApi('v1/user_comment/reportCmt', 'post', { comment_id: _id, reason_type: type, reason_content: reason });
        if (dataCall && dataCall.status == 1) {
            setReport(true)
            handleCancel();
            NotificationManager.success('Cảm ơn bạn đã báo cáo. Chúng tôi sẽ xem xét và phản hồi lại bạn sớm!', '', 1300);
        } else {
            NotificationManager.error(dataCall.message, '', 1300);
        }
    }

    useEffect(() => {
        if (is_mod && author_id == props.user_id && Number(total_thank) > 0) {
            setIsThank(true)
        }
    }, [props.user_id]);

    return (
        <>
            <RateStarPopup visible={visiblePopupStar} onCancel={handleCancel} onFinish={onFinishPopupStar} handleClickOutSite={handleHidePopup} content={reasonRate} handleChange={handleChangeInputStar} />
            <ReportPopup visible={visiblePopupReport} onCancel={handleCancel} handleClickOutSite={handleHidePopup} onFinish={onFinishPopupReport} />

            {!root_comment_id ? (
                // Comment cha
                <div className="boxAction">
                    <div className="left">
                        <a className={isUpvote ? "btnFrameIcom upvote" : "btnFrameIcom downvote"} onClick={() => callApiUpvote()}>Upvote ({(Number(upvoteCount) || 0)})</a>



                        {props.permission_cmt && (props.is_mod_hoidap > 0 || (props.data_comment.status != 1 && props.data_comment.last_ask_time == props.data_comment.create_time) || author_id == props.user_id) ? 
                            <a className="btnFrameIcom answer" onClick={handleReplied}>Trả lời</a> : ''
                        }

                        <a className={"btnFrameIcom save " + (isReport ? "active" : "")} onClick={() => handleShowPopup('report')}>s</a>
                    </div>
                </div>

            ) : (

                // Khong phai Comment cha
                <div className="boxAction">
                    <div className="left">
                        {/* <a className="btnFrameIcom answer">Trả lời</a> */}
                        {is_mod ? (
                            <a className={isThank ? "btnFrameIcom thank active" : "btnFrameIcom thank"} onClick={() => callApiThank()}>Cảm ơn ({totalThank})</a>
                        ) : (<></>)}
                        {
                            author_id != props.user_id ? <a className={"btnFrameIcom save " + (isReport ? "active" : "")} onClick={() => handleShowPopup('report')}>s</a> : ''
                        }
                    </div>

                    {/* Rating star */}
                    {is_mod && props.data_comment.status == 1 ? (
                        <div className="rateStar" xxx={author_id} yyy={props.user_id}>
                            <ul className="rattingStar">
                                {dataStarRating.reverse().map((item, index) =>
                                    <li className={item.star <= totalStar ? "selected" : ""} onClick={() => handleRatingStar(item.star)} key={index}>
                                        <span className="tooltip">{item.tip}</span>
                                        <span className="star"></span>
                                    </li>
                                )}

                            </ul>
                        </div>
                    ) : (<></>)}

                </div>
            )}
        </>

    )

}